import { render, staticRenderFns } from "./NaturalNumeration.vue?vue&type=template&id=877809b4&"
import script from "./NaturalNumeration.vue?vue&type=script&lang=js&"
export * from "./NaturalNumeration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports